"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneIcon = exports.PhoneRow = exports.PhoneNumberText = exports.TelephoneControl = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactFeather = require("react-feather");

var _Headline = _interopRequireDefault(require("../../Elements/Headline"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var TelephoneControl = _styledComponents.default.a(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)(["\n  font-family: ", ";\n  font-size: 20px;\n  text-decoration: none;\n  color: ", ";\n"], ["\n  font-family: ", ";\n  font-size: 20px;\n  text-decoration: none;\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.fonts.mrEaves;
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.orange;
});

exports.TelephoneControl = TelephoneControl;
var PhoneNumberText = (0, _styledComponents.default)(_Headline.default).attrs({
  m: 0,
  mb: 0,
  fontSize: 5,
  color: 'orange'
})(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)([""], [""])));
exports.PhoneNumberText = PhoneNumberText;
PhoneNumberText.displayName = 'PhoneNumberText';

var PhoneRow = _styledComponents.default.div(templateObject_3 || (templateObject_3 = (0, _tslib.__makeTemplateObject)(["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  color: ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.orange;
});

exports.PhoneRow = PhoneRow;
var PhoneIcon = (0, _styledComponents.default)(_reactFeather.Phone)(templateObject_4 || (templateObject_4 = (0, _tslib.__makeTemplateObject)(["\n  margin-right: 4px;\n  fill: ", ";\n  stroke: none;\n"], ["\n  margin-right: 4px;\n  fill: ", ";\n  stroke: none;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.colors.orange;
});
exports.PhoneIcon = PhoneIcon;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;